import { Injectable } from '@angular/core';
// We can include more pipes if needed
import { DecimalPipe, CurrencyPipe } from '@angular/common';
import * as moment from 'moment';

import { UserProfileService } from '../api/user-profile.service';

@Injectable({
  providedIn: 'root',
})
export class HelperService {

  constructor(
    private decimalPipe: DecimalPipe,
    private currencyPipe: CurrencyPipe,
    private userProfileService: UserProfileService
  ) { }

  // Uses the user's currency to format the values
  // CurrencyPipe returns values like JPY123,345 - USD123,345.00, etc.
  // Reference: https://en.wikipedia.org/wiki/ISO_4217
  getCurrencyFormat(value: number, fieldName?: string): number {
    let transformedValue = 0;
    if (value) {
      let currencyLabel = 'USD';
      if (this.userProfileService.getCurrencyLabelLocalStorage()) {
        currencyLabel = this.userProfileService.getCurrencyLabelLocalStorage();
      }
      const currency_decimals = this.userProfileService.getCurrencyDecimalsLocalStorage();
      const digitsInfo = '1.' + currency_decimals + '-' + currency_decimals;
      // Negatives values
      if (value < 0) {
        transformedValue = +this.currencyPipe
          .transform(value, currencyLabel, 'code', digitsInfo)
          .substring(4)
          .replace(/,/g, '');
        transformedValue = transformedValue * -1;
      } else {
        transformedValue = +this.currencyPipe
          .transform(value, currencyLabel, 'code', digitsInfo)
          .substring(3)
          .replace(/,/g, '');
      }
    }
    return transformedValue;
  }

  // Used to transform numbers to 2,000,000.00 or 2,000,000
  // Usefull for templates variables
  transformNumber(value: number): string {
    let transformedValue = '';
    if (+this.userProfileService.getCurrencyDecimalsLocalStorage() === 0 && value) {
      transformedValue = this.decimalPipe.transform(value, '.0-0');
    } else {
      transformedValue = this.decimalPipe.transform(value, '.2-2');
    }
    return transformedValue;
  }

  roundNumber(value: number, decimals: number) {
    return Number(Math.round(+(value + 'e' + decimals)) + 'e-' + decimals);
  }

  truncateDecimals(value: string, decimals: number) {
    if (value.includes('.')) {
      const splitValues = value.split('.');
      let decimalPart = splitValues[1];
      if (decimalPart.length > decimals) {
        decimalPart = decimalPart.substring(0, decimals);
      }
      value = splitValues[0] + '.' + decimalPart;
    }
    return parseFloat(value);
  }

  fixNumber(value: any, decimals: number) {
    return Number.parseFloat(value).toFixed(decimals);
  }

  transformDate(date: string, dateSeparator: string = '/', location: 'reports' | 'summary' = 'summary'): string {
    const userCountry = this.userProfileService.getCountryLocalStorage();
    // Summary, default format DD/MM/YYYY
    let defaultDateFormat = `DD${dateSeparator}MM${dateSeparator}YYYY`;
    if (date) {
      if (location === 'summary') {
        switch (userCountry) {
          case 'JPN':
            defaultDateFormat = `YYYY${dateSeparator}MM${dateSeparator}DD`;
            break;
        }
      } else {
        // Reports, default YYYY-MM-DD
        defaultDateFormat = `YYYY${dateSeparator}MM${dateSeparator}DD`;
      }
      return moment(date, 'YYYY-MM-DD').format(defaultDateFormat);
    }
    return null;
  }

}
